<template>
  <div class="content">
    <div class="content">
      <div class="md-layout">
        <div
            class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
        >
          <p-s-table
                  tableHeaderColor="purple"
                  title="Ausschreibung"
                  v-bind:subTitle="this.date"
                  showFilter="true"
                  sortBy="customerArticleNumber"
                  v-bind:data="this.positions"
                  v-bind:dict="this.positionsDict"
          ></p-s-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { PSTable } from "@/components";
  import store from '@/store/index.js';
  import api from "@/api/api";

export default {
  name: "PriceBenchmark",
  components: {
    PSTable
  },
  data() {
    return {
      positions: [],
      positionsDict: [
        { key: 'customerArticleNumber', label: 'Artikelnummer', type: 'string'},
        { key: 'customerArticleDescription', label: 'Bezeichnung', type: 'string'},
        { key: 'supplier', label: 'Lieferant', type: 'string'},
        { key: 'container', label: '# Behälter', type: 'number'},
        { key: 'basePrice', label: 'Grundpreis (pro 100)', type: 'price'},
        { key: 'quantity', label: 'Menge', type: 'number'},
        { key: 'kanbanvalue', label: 'Kanbanwert', type: 'price'},
      ],
      date: ""
    }
  },
  created () {
    store.commit("setLoading", true);

    api.getTenderById(this.$route.params.id).then((result) => {
      this.date = new Date(result.data[0].createdAt).toLocaleString();
      this.positions = result.data;

      store.commit("setLoading", false);
    });
  },
};
</script>

